module.exports = __webpack_public_path__ + "img/google-calendar.c30f50fa.png";